export enum adminApplicationsListTypes {
    FETCH_ADMIN_APPLICATIONS_LIST_REQUEST = "FETCH_ADMIN_APPLICATIONS_LIST_REQUEST",
    FETCH_ADMIN_APPLICATIONS_LIST_SUCCESS = "FETCH_ADMIN_APPLICATIONS_LIST_SUCCESS",
    FETCH_ADMIN_APPLICATIONS_LIST_FAILURE = "FETCH_ADMIN_APPLICATIONS_LIST_FAILURE",
  }